module.exports = __webpack_public_path__ + "static/szubryt-9d343cc67763572ebb7b2cf73c404d9e.png";